import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from "rxjs";
import { TranslationService } from "../Tenant/Applications/Airsweb/Services/translation.service";

@Pipe({
    name: "translate", pure: true
})
export class TranslationPipe implements PipeTransform {
    
    constructor(private translationService: TranslationService) {

    }
    transform(value: string, property: string): Observable<string> {
        return this.translationService.getTranslation(value, property);
    }
}